import React from "react";

const STATUS_CONFIG = {
    requested:    { label: "Requested",    className: "orders-badge--gray" },
    invoice_sent: { label: "Invoice Sent", className: "orders-badge--blue" },
    paid:         { label: "Paid",         className: "orders-badge--indigo" },
    shipped:      { label: "Shipped",      className: "orders-badge--orange" },
    handoff_partially_confirmed: { label: "Pickup in Progress", className: "orders-badge--orange" },
    completed:    { label: "Completed",    className: "orders-badge--green" },
    denied:       { label: "Denied",       className: "orders-badge--red" },
    cancelled:    { label: "Cancelled",    className: "orders-badge--gray-dark" },
    approved:     { label: "Approved",     className: "orders-badge--green" },
    fulfilled:    { label: "Completed",    className: "orders-badge--green" },
};

const OrderStatusBadge = ({ status }) => {
    const config = STATUS_CONFIG[status] || { label: status, className: "orders-badge--gray" };

    return (
        <span className={`orders-badge ${config.className}`}>
            {config.label}
        </span>
    );
};

export default OrderStatusBadge;
